import React, { useState, useRef, useEffect } from "react";
import EnqueryData from "./EnqueryData";
import LeadsOrders from "./LeadsOrders";
import { Link } from "react-router-dom";
import Cateringscrollingorder from "./Cateringscrollingorder";
import Cateringpackagesorders from "./Cateringpackagesorders";
const cateringOffers = [
  {
    id: 1,
    gole: "Buffet Lunch",
    description: "Enjoy unlimited buffet with 20% off!",
    couponCode: "BUFFET20",
    startDate: "2025-09-01",
    endDate: "2025-09-30",
    discountPercentage: 20,
    offerType: "buffet",
  },
  {
    id: 2,
    gole: "Wedding Package",
    description: "Flat 15% off on wedding catering bookings.",
    couponCode: "WED15",
    startDate: "2025-09-10",
    endDate: "2025-12-31",
    discountPercentage: 15,
    offerType: "wedding",
  },
  {
    id: 3,
    gole: "Birthday Special",
    description: "Book birthday catering & get 1kg cake free 🎂",
    couponCode: "BIRTHDAYFREE",
    startDate: "2025-09-05",
    endDate: "2025-11-30",
    discountPercentage: 10,
    offerType: "birthday",
  },
  {
    id: 4,
    gole: "Corporate Lunch",
    description: "Get 25% off on corporate lunch packages.",
    couponCode: "CORP25",
    startDate: "2025-09-01",
    endDate: "2025-10-31",
    discountPercentage: 25,
    offerType: "corporate",
  },
];
function CateringOrders() {
  const [activeTab, setActiveTab] = useState("first"); // default tab
  const isMobile = window.innerWidth <= 768;

  const [isPaused, setIsPaused] = useState(false);

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };
  const [expandedCard, setExpandedCard] = useState(null); // ✅ expand state
  const scrollRef = useRef(null);
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let scrollInterval;

    if (scrollContainer && !isPaused) {
      scrollInterval = setInterval(() => {
        if (
          scrollContainer.scrollTop + scrollContainer.clientHeight >=
          scrollContainer.scrollHeight
        ) {
          scrollContainer.scrollTop = 0;
        } else {
          scrollContainer.scrollTop += 1; // scroll speed
        }
      }, 50);
    }

    return () => clearInterval(scrollInterval);
  }, [isPaused]); // pause state control karega


  const getOfferColor = (type) => {
    switch (type) {
      case "buffet":
        return "#ff6f61";
      case "wedding":
        return "#6a5acd";
      case "birthday":
        return "#ffb347";
      case "corporate":
        return "#2e8b57";
      default:
        return "#333";
    }
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "947px",
        margin: '150px 230px',
        marginTop: "150px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <p
        className="breadcrumb maamaas-home-bredcum"
        style={{
          position: "fixed",
          top: isMobile ? "50px" : "80px",
          left: isMobile ? "5px" : "275px",
          width: "100%",
          backgroundColor: "#fff",
          zIndex: 1000,
          padding: "10px 0",
          fontSize: isMobile ? "14px" : "18px",
          fontWeight: isMobile ? "normal" : "bold",
          textAlign: "center",
          margin: 0,
        }}
      >
        <Link
          to="/Newmainlandingpage"
          style={{
            color: "purple",
            fontWeight: "bold",
            textDecoration: "none",
          }}
        >
          Home
        </Link>
        {/* <span className="separator"> &gt; </span>
                        <Link
                          to="/company"
                          style={{
                            color: "purple",
                            fontWeight: "bold",
                            textDecoration: "none",
                          }}
                        >
                          DigitalMenuBillings
                        </Link> */}
        <span className="separator"> &gt; </span>
        <Link
          to="/CateringOrders"
          style={{
            color: "purple",
            fontWeight: "bold",
            textDecoration: "none",
          }}
        >
          Order_Management
        </Link>


      </p>
      {/* Tabs Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          marginBottom: "20px",
          marginTop: "-20px"
        }}
      >
        <button
          onClick={() => setActiveTab("first")}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            border: "1px solid rgb(177 93 198)",
            borderRadius: "8px",
            fontWeight: "bold",
            backgroundColor: activeTab === "first" ? "rgb(177 93 198)" : "white",
            color: activeTab === "first" ? "white" : "rgb(177 93 198)",
            transition: "0.3s",
          }}
        >
          Status
        </button>

        {/* <button
          onClick={() => setActiveTab("second")}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            border: "1px solid rgb(177 93 198)",
            borderRadius: "8px",
            fontWeight: "bold",
            backgroundColor: activeTab === "second" ? "rgb(177 93 198)" : "white",
            color: activeTab === "second" ? "white" : "rgb(177 93 198)",
            transition: "0.3s",
          }}
        >
          Bookings
        </button> */}

        <button
          onClick={() => setActiveTab("third")}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            border: "1px solid rgb(177 93 198)",
            borderRadius: "8px",
            fontWeight: "bold",
            backgroundColor: activeTab === "third" ? "rgb(177 93 198)" : "white",
            color: activeTab === "third" ? "white" : "rgb(177 93 198)",
            transition: "0.3s",
          }}
        >
          Reports
        </button>
      </div>

      {/* Tabs Content third */}
      <div

      >
        {activeTab === "first" && <LeadsOrders />}
        {/* {activeTab === "second" && <Catreingleads />} */}
        {activeTab === "third" && <Cateringpackagesorders />}
      </div>


      <div>
        <Cateringscrollingorder />
      </div>
    </div>




  );
}

export default CateringOrders;
